import React, { useState } from 'react';
import { GradeContext } from 'context/Context';

const GradeProvider = ({ children }) => {
    const [grade, setGrade] = useState(null);
    const [loId, setLoId] = useState(null);

    return (
        <GradeContext.Provider value={{ grade, setGrade, loId, setLoId }}>
            {children}
        </GradeContext.Provider>
    );
};

export default GradeProvider;
